export enum PortfolioSelectionType {
  CURRENT = 'CURRENT',
  SUGGESTED = 'SUGGESTED',
}
